export default {_name:'field.dropdown',module:'Field',view:'Element/Field/Dropdown',options:{key:'dropdown',events:{onChange:'persistOption'}}}